<template>
  <div 
      @mouseover="isHover = true"
      @mouseleave="isHover = false"
      >
    <p class="arriba">{{ titulo }}</p>
    <p class="abajo">
      <b v-if="typeof hover == 'undefined' || !isHover">{{ formatter == null ? valor : formatter(valor) }}</b>
      <b v-else>{{ hover }} </b>
    </p>
  </div>
</template>

<script>
export default {
  name: 'detailHover',
  props: {
    titulo: {
      type: String,
      default: '',
    },
    valor: {
      type: String,
      default: '',
    },
    formatter: null,
    hover: null

  },
  data(){
    return {
      isHover : false,
    }
  }
}
</script>

<style scoped>
  div{
    text-align: center;
  }
  p{
    margin-top: 0px;
    margin-bottom: 0px;
  }
  p.arriba {
      font-size: 13px;
  }
  p.abajo {
      font-size: 25px;
      white-space: nowrap;
  }
</style>
